import { useAppDispatch, useAppSelector } from "@app/store";
import { useCallback, useEffect, useState } from "react";
import { AuthForm, EnrollmentOtpForm, RegisterForm } from "./api";
import {
  enrollmentOtp,
  login,
  logout,
  refreshAccessToken,
  register,
} from "./slice";

export const useAuth = () => {
  const state = useAppSelector((state) => state.auth);

  const dispatch = useAppDispatch();

  const [isSuperUser, setIsSuperUser] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isSupport, setIsSupport] = useState(false);
  const [isTrader, setIsTrader] = useState(false);
  const [isTeamlead, setIsTeamlead] = useState(false);
  const [isAgent, setIsAgent] = useState(false);

  useEffect(() => {
    const isSuper = state.roles?.includes("super_user");
    const isAdmin = isSuper || state.roles?.includes("administrator");
    const isCustomerSupport =
      isAdmin || state.roles?.includes("customer_support");
    const isTrader = state.roles?.includes("trader");
    const isTeamlead = state.roles?.includes("trader_teamlead");
    const isAgent = state.roles?.includes("merchant_agent");

    setIsSuperUser(!!isSuper);
    setIsAdmin(!!isAdmin);
    setIsSupport(!!isCustomerSupport);
    setIsTrader(!!isTrader);
    setIsTeamlead(!!isTeamlead);
    setIsAgent(!!isAgent);
  }, [state.roles]);

  const authHandler = useCallback(
    (data: AuthForm) => dispatch(login(data)).unwrap(),
    [dispatch]
  );

  const registerHandler = useCallback(
    (data: RegisterForm) => dispatch(register(data)).unwrap(),
    [dispatch]
  );

  const enrollmentOtpHandler = useCallback(
    (data: EnrollmentOtpForm) => dispatch(enrollmentOtp(data)).unwrap(),
    [dispatch]
  );

  const refreshTokenHandler = useCallback(
    () => dispatch(refreshAccessToken()).unwrap(),
    [dispatch]
  );

  const logoutHandler = useCallback(() => dispatch(logout()), [dispatch]);

  return {
    state,
    isSuperUser,
    isAdmin,
    isSupport,
    isTrader,
    isTeamlead,
    isAgent,
    auth: authHandler,
    register: registerHandler,
    enrollmentOtp: enrollmentOtpHandler,
    refreshToken: refreshTokenHandler,
    logout: logoutHandler,
  };
};
